import styled from "styled-components"

export const AbilitiesContainerLi = styled.li`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
`

export const AbilitiesValueP = styled.p`
  align-items: center;
  color: black;
  display: flex;
  font-size: 1.375rem;
  gap: 5px;
  justify-content: center;
`
